enum PasskeyStatusEnum {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
}

export default PasskeyStatusEnum;
